import React from "react";

import { Provider } from "react-redux";
import { store } from "./Redux/store";

import Box, { Item } from "devextreme-react/box";

import Chart from "./ChartContainer";
import MenuContainer from "./MenuContainer";

export default function Visualization() {
  return (
    <React.Fragment>
      <Provider store={store}>
        <Box direction="col" width="100%" height={250}>
          <Item ratio={1}>
            <div className="label">Visualization:</div>
            <MenuContainer />
          </Item>
          <Item ratio={2} baseSize={0}>
            <Box direction="row" width="100%" height="100%">
              <Item ratio={3}>
                <Box direction="col" width="100%" height="100%">
                  <Item ratio={1}>
                    <Chart />
                  </Item>
                  <Item ratio={1}>{/* <div>Grid</div> */}</Item>
                </Box>
              </Item>
              <Item ratio={1}>
                <div>Options</div>
              </Item>
            </Box>
          </Item>
        </Box>
      </Provider>
    </React.Fragment>
  );
}
